import { createApp } from 'vue'
import App from './App.vue'
import coreui from '@coreui/vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faLightbulb } from '@fortawesome/free-regular-svg-icons'
import './main.scss'
import 'odometer/themes/odometer-theme-car.css'

library.add(faLightbulb)

createApp(App).use(coreui).component('font-awesome-icon', FontAwesomeIcon).mount('#app')
